import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Flatpickr from "react-flatpickr";

import BreadCrumb from "common/breadcrumb";
import LoadingComponent from "common/components/loader";

import { BrandingData } from "admin-portal/settings/branding";
import { Job, JobAllocation, JobProduct, JobService } from "models/job/job";

import { GetJobs } from "api/job";

import { UpcomingScheduledData } from "common/data";
import { JobStatuses } from "models/settings/branding";
import { AppUtility } from "utility/app-utility";

const DailySalesReport: React.FC = () => {
  document.title = "Daily Sales" + BrandingData.titleSuffix;
  const title = "Daily Sales Report";
  const pageTitle = "Daily Sales";
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState<Job[]>([]);

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [totalSales, setTotalSales] = useState(0.0);

  useEffect(() => {
    loadReportData();
  }, []);
  useEffect(() => {
    loadReportData();
  }, [selectedDate]);

  const loadReportData = async () => {
    setLoading(true);
    let _dt = selectedDate == null ? new Date() : selectedDate!;
    let _dtS =
      _dt.getFullYear() +
      "-" +
      (_dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      _dt.getDate().toString().padStart(2, "0");

    const res = await GetJobs(
      {
        paidFrom: _dtS + " 00:00",
        paidTo: _dtS + " 23:59",
        jobStatuses: "5,6,7",
      },
      undefined,
      1000,
      1
    );
    if (!(res?.status?.isError ?? false) && res?.data) {
      setData(res?.data ?? []);
      setTotal(res?.totalResultCount ?? 0);
      setTotalSales(
        (res?.data ?? []).reduce((total, item) => {
          // Replace `item.sales` with the actual property holding the sales value
          return total + (item.totalAmount ?? 0);
        }, 0)
      );
    } else {
      setData([]);
      setTotal(0);
    }
    setLoading(false);
  };

  const months: string[] = ["JAN", "FEB", "MAR", "APR", "JUN", "JUL", "AUG", "SEP", "NOV", "DEC"];

  const getSLineTotal = (job: Job): number => {
    let _tot = job?.totalAmount ?? 0.0;
    return _tot;
  };
  return (
    <React.Fragment>
      <BreadCrumb title={title} pageTitle={pageTitle} />
      <div className="min-w-[50%]">
        <div className="card">
          <div className="card-body">
            <div className="flex flex-col gap-4 mt-3">
              <div className="flex flex-col gap-3">
                <div className="flex flex-row">
                  <label htmlFor="endDate" className="inline-block mb-2 text-base font-medium p-4">
                    Date
                  </label>
                  <Flatpickr
                    id="endDate"
                    className={`form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 `}
                    options={{
                      dateFormat: "d M, Y",
                      locale: "default",
                    }}
                    placeholder="Select Date"
                    onChange={(date) => {
                      setSelectedDate(date[0]);
                    }}
                    value={selectedDate ?? ""}
                  />
                </div>
                <div className="flex flex-row">{loading && <LoadingComponent />}</div>
              </div>

              {(data || []).map((item: Job, key: number) => {
                const _currentDt = new Date();
                _currentDt.setHours(0);
                _currentDt.setMinutes(0);
                _currentDt.setSeconds(0);
                const _dt =
                  (item.paidDate ?? item.insertedTime ?? "") != ""
                    ? new Date(item.paidDate ?? item.insertedTime ?? "")
                    : _currentDt;
                return (
                  <>
                    <div className="flex gap-3 bg-gray-100">
                      <div className="flex flex-col items-center justify-center bg-gray-100 size-12 border rounded-sm border-slate-200 dark:border-zink-500 shrink-0 m-2">
                        <h6>
                          {_dt.getDate().toString().padStart(2, "0")} {/* {item.paidDate ?? item.insertedTime ?? ""} */}
                        </h6>
                        <span className="text-sm text-slate-500 dark:text-zink-200">{months[_dt.getMonth()]}</span>
                      </div>
                      <div className="flex flex-col items-center  justify-start px-4 pt-4">
                        <h6>{item?.vehicle?.vehicleNo ?? ""}</h6>
                        <span className="text-sm text-slate-500 dark:text-zink-200"></span>
                      </div>
                      <div className="grow">
                        <h6 className="mb-1 text-slate-500 dark:text-zink-200 p-4">
                          {item.description ?? ""}{" "}
                          {/*   {item.time && (
                        <small className="inline-block px-2 font-medium border border-transparent rounded text-[11px] py-0.5 bg-slate-100 text-slate-500 dark:bg-slate-500/20 dark:text-zink-200 dark:border-transparent">
                          {item.time}
                        </small>
                      )} */}
                        </h6>
                        {/*  <p className="text-slate-500 dark:text-zink-200"></p> */}
                      </div>
                    </div>

                    <div className="flex gap-3">
                      <div className="w-full">
                        <div className="rounded-lg border border-gray-300 p-4 shadow-md">
                          {/* Added Services Section */}
                          <div className="grid grid-cols-1 gap-x-5 mt-4">
                            {(item.services ?? []).map((service: JobService, index) => (
                              <div key={index} className="grid grid-cols-1 lg:grid-cols-12 gap-4 mb-2 items-center">
                                <span className="lg:col-span-6">
                                  {((service.description ?? service.service?.name ?? "") + " <M>").replace(
                                    /<.*?>/g,
                                    ""
                                  )}
                                </span>
                                <div className="lg:col-span-6">
                                  <label
                                    htmlFor={`price_tax_${index}`}
                                    className="inline-block m-4  text-sm text-right"
                                  >
                                    {(service.totalAmount ?? 0).toFixed(2)}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="grid grid-cols-1 gap-x-5 mt-4">
                            {(item.products ?? []).map((prd: JobProduct, index) => (
                              <div key={index} className="grid grid-cols-1 lg:grid-cols-12 gap-4 mb-2 items-center">
                                <span className="lg:col-span-6">
                                  {(prd.description ?? prd.product?.name ?? "").replace(/[<>]/g, "")}
                                </span>

                                <div className="lg:col-span-6">
                                  <label
                                    htmlFor={`price_tax_${index}`}
                                    className="inline-block m-4  text-sm text-right"
                                  >
                                    {(prd.totalAmount ?? 0).toFixed(2)}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="flex justify-end gap-2 mt-5 font-bold">
                          Total : {AppUtility.FormattedPrice(item.totalAmount ?? 0.0)}
                        </div>
                      </div>
                    </div>

                    <div className="flex gap-3">
                      <div className="border-t border-gray-300 w-full h-0"> </div>
                    </div>
                  </>
                );
              })}
            </div>

            <div className="flex gap-3 w-full">
              <div className="flex justify-end font-bold text-lg w-full">
                Total Sales: {AppUtility.FormattedPrice(totalSales)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DailySalesReport;
